module.exports = __webpack_public_path__ + "img/mon_24.97292354.png";